module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/0.25-70744f30493bf28ef591c72837c7772b.svg";